// src/components/shared/Card.tsx
import React from "react";
import cn from "classnames"; // Keep classnames for flexibility

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode;
    className?: string; // Allow passing additional classes
    disclaimer?: string;
}

const Card: React.FC<CardProps> = ({ children, className, disclaimer, ...props }) => {
    return (
        <div
            className={cn(
                // Removed 'relative' class to avoid potential stacking context issues with the dropdown
                "card transition-all duration-300 w-full",
                className, // Merge base styles with any additional classes passed
            )}
            {...props} // Pass down other div attributes like id, style, etc.
        >
            {children ? (
                children
            ) : (
                <div className="flex items-center justify-center h-96 flex-col gap-4 ">
                    <img src="/images/wallet-search.svg" alt="Wallet Search" className="w-12 h-12" />
                    {disclaimer && <p className="text-foreground/50 w-60 text-center">{disclaimer}</p>}
                </div>
            )}
        </div>
    );
};

export default Card;
